import { Component, Input, OnInit, Self } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NgControl } from '@angular/forms';
import { noop } from 'rxjs';
import { ValidatorCheck } from '../../utils/validator.check';


@Component({
    selector: 'pim-input-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.sass'],
    standalone: false
})
export class TextareaComponent implements ControlValueAccessor, OnInit {
	@Input()
	id!: string;

	@Input()
	tabindex!: number;

	@Input()
	label: string = '';

	@Input()
	rows: number = 5;

	@Input()
	displayAsCode: boolean = false;

	@Input()
	readonly: boolean = false;

	@Input()
	maxRows: number = 10;

	required: boolean = false;

	private internalValue: any = '';
	private onChangeCallback: (_: any) => void = noop;
	control!: UntypedFormControl;

	constructor(private validatorCheck: ValidatorCheck, @Self() public ngControl: NgControl) {
		this.ngControl.valueAccessor = this;
	}

	ngOnInit(): void {
		this.control = this.ngControl.control as UntypedFormControl;
		this.required = this.validatorCheck.isRequired(this.control);
	}

	get value(): any {
		return this.internalValue;
	}

	set value(v: any) {
		if (v !== this.internalValue) {
			this.internalValue = v?.trim();
			this.onChangeCallback(this.internalValue);
		}
	}

	get fullLabel(): string {
		const requiredAstersik = this.required ? ' *' : '';
		return `${this.label}${requiredAstersik}`;
	}

	resetCursor(event: any): void {
		const txtElement = event.target;
		if (txtElement.setSelectionRange) {
			txtElement.focus();
			txtElement.setSelectionRange(0, 0);
		} else if (txtElement.createTextRange) {
			const range = txtElement.createTextRange();
			range.moveStart('character', 0);
			range.select();
		}
		txtElement.scrollTo(0, 0);
	}

	writeValue(obj: any): void {
		if (this.value !== obj) {
			this.value = obj;
		}
	}

	registerOnChange(fn: any): void {
		this.onChangeCallback = fn;
	}

	registerOnTouched(): void {
	}

}
